<template>
	<span class="corner-ribbon" :class="classes" :title="title"></span>
</template>

<script>
export default
{
	props:
	{
		title: String,

		top:
		{
			type:    Boolean,
			default: false,
		},

		bottom:
		{
			type:    Boolean,
			default: false,
		},

		left:
		{
			type:    Boolean,
			default: false,
		},

		right:
		{
			type:    Boolean,
			default: false,
		},

		fixed:
		{
			type:    Boolean,
			default: true,
		},
	},

	computed:
	{
		classes()
		{
			return {
				'fixed':        this.fixed,
				'left-top':     this.left && this.top,
				'left-bottom':  this.left && this.bottom,
				'right-top':    this.right && this.top,
				'right-bottom': this.right && this.bottom,
			}
		},
	},
}
</script>